<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<div class="title-frontMatter"><a href="#/e9781466822825_toc01#toctitle45" id="title45"><span><strong class="b">THE TURING TEST</strong></span></a></div>
<div class="p-indent"><span>In 1950, Alan M. Turing, one of the earliest pioneers of computer science, considered the question of whether a machine could ever think. But because it is so hard to define <em class="i">thinking</em> he proposed to start with an ordinary digital computer and then asked whether, by increasing its memory and speed, and providing it with a suitable program, it might be made to play the part of a man? His answer:</span></div>
<div class="p-indent"><span><em class="i">“The question, ‘Can machines think?’ I believe to be too meaningless to deserve discussion. Nevertheless I believe that at the end of the century the use of words and general, educated opinion will have altered so much that one will be able to speak of machines thinking without expecting to be contradicted.”</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-d"><span>Alan Turing, 1950</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466822825_fm01.vue?594fa108